import { render } from "./SidebarWidget.vue?vue&type=template&id=cdd20cde"
import script from "./SidebarWidget.vue?vue&type=script&lang=js"
export * from "./SidebarWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__